import React, { useState } from 'react'
import { CountriesContext } from './CountriesContext'
import { useGetCountriesQuery } from '../../graphql/api/queries/GetCountries.generated'

import LoadingError from '../../components/LoadingError'
import type { Country } from '../../graphql/api/types'
import { LoadingCircular } from '../../components/LoadingCircular'

const CountriesContextProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [error, setError] = useState<Error | null>(null)
  const [countries, setCountries] = useState<ReadonlyArray<Country>>([])

  const { loading } = useGetCountriesQuery({
    fetchPolicy: 'cache-first',
    onError: setError,
    onCompleted: ({ countries }) => setCountries((countries || []).map((country) => country as Country)),
  })

  if (loading) return <LoadingCircular />

  if (error) return <LoadingError errorText={error.message} />

  return <CountriesContext.Provider value={countries}>{children}</CountriesContext.Provider>
}

export default CountriesContextProvider
